(()=>{
const body=document.body,group=document.getElementById('header-group');
if(!body.classList.contains('vics-immersive-home')||!group)return;
const hero=document.querySelector('.vics-immersive-hero');
if(!hero)return;
let frame=0;
const host=document.createElement('div');host.className='vics-hero-header-host';group.before(host);host.append(group);
body.classList.add('vics-reference-header-ready');
const visible=e=>!!(e&&e.getClientRects().length&&e.getBoundingClientRect().height);
const sync=()=>{
 frame=0;
 const activeMenu=[...group.querySelectorAll('.vics-navigation__details[open],.zora-mobile-drawer[open],.dropdown-localization__button[aria-expanded="true"]')].some(visible);
 body.classList.toggle('vics-hero-menu-open',activeMenu);
 let scrollOffset=Math.max(0,window.scrollY||0,document.scrollingElement?.scrollTop||0);
 for(let parent=hero.parentElement;parent;parent=parent.parentElement){scrollOffset=Math.max(scrollOffset,parent.scrollTop||0);}
 body.classList.toggle('vics-hero-at-top',scrollOffset<=24);
 body.classList.toggle('vics-hero-header-fixed',scrollOffset>24);
};
const schedule=()=>{if(!frame)frame=requestAnimationFrame(sync);};
const measure=()=>{
 const header=group.querySelector('.header-section');
 const nav=[...group.querySelectorAll('[data-vics-navigation]')].find(e=>!e.classList.contains('zora-mobile-drawer__desktop-panel')&&visible(e));
 const height=(header?.getBoundingClientRect().height||0)+(nav?.closest('.shopify-section')?.getBoundingClientRect().height||0);
 if(height>0)body.style.setProperty('--vics-overlay-header-height',height+'px');
 const promo=group.querySelector('.vics-promo-bars-section');
 const promoHeight=promo?.getBoundingClientRect().height||0;
 body.style.setProperty('--vics-hero-promo-height',promoHeight+'px');
 const hostRect=host.getBoundingClientRect();
 body.style.setProperty('--vics-hero-header-left',hostRect.left+'px');
 body.style.setProperty('--vics-hero-header-width',hostRect.width+'px');
 schedule();
};
const onScroll=event=>{
 const target=event.target;
 if(target!==document&&target!==document.documentElement&&target!==document.body&&!(target instanceof Element&&target.contains(hero)))return;
 schedule();
};
document.addEventListener('scroll',onScroll,{passive:true,capture:true});
window.addEventListener('pageshow',measure);
window.addEventListener('resize',measure,{passive:true});
group.addEventListener('toggle',schedule,true);
group.addEventListener('click',schedule);
new MutationObserver(schedule).observe(group,{subtree:true,attributes:true,attributeFilter:['open','aria-expanded']});
if(window.ResizeObserver)new ResizeObserver(measure).observe(group);
measure();sync();
})();